import styled from '@emotion/styled/macro';

const StyledButton = styled.button`
  color: #C25026;
  border-color: #C25025;
  background: white;
  
  &.primary {
    color: white;
    background: linear-gradient(180deg, #EB7346 0%, #C25026 100%);
    border: none;
  }
  
    border-radius: 50px;
    box-sizing: border-box;
    font-size: 1.125rem;
    font-weight: 500;
    padding: 1.25rem;
    text-transform: uppercase;
`

interface ButtonProps {
    onClick?: React.MouseEventHandler;
    text: string;
    primary?: true;
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
}

export default function Button({ onClick, text, type = 'button', primary }: ButtonProps) {
    return <StyledButton className={primary && "primary"} onClick={onClick} type={type}>{text}</StyledButton>
}
